// extracted by mini-css-extract-plugin
export default {"ai-button":"AIButton_ai-button__9zmxV","popover":"AIButton_popover__z41dj","loading-value":"AIButton_loading-value__INqGH"};